import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    confirmText: 'I have read and accept the contract',
    next: 'Continue',
    title: 'Insurance policy',
    warningText:
      'Shine Business will soon be **{amount} per month**. This price change matches the launch of new features: access and cards for your team, accounting access, etc.',
    warningTitle: '**Information about Shine Business**',
  },
  fr: {
    confirmText: 'J’ai lu et j’accepte le contrat',
    next: 'Continuer',
    title: 'Police d’assurance',
    warningText:
      'L’offre Shine Business passera bientôt à **{amount} par mois**. Ce changement de tarif accompagne le lancement de nouvelles fonctionnalités : accès restreints et cartes pour votre équipe, accès comptable, assurances additionnelles...',
    warningTitle: '**Information concernant l’offre Shine Business**',
  },
} as const);

export default locales;
